import Vue from 'vue'
import Router from 'vue-router'
import { Auth } from './service/Auth.js'

Vue.use(Router)

const asyncView = path => () => import(`./views/${path}`)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: asyncView('Home'),
      meta: {
        title: 'Home',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/atividades',
      name: 'atividade',
      component: asyncView('atividade/Listar'),
      meta: {
        title: 'Atividades',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/atividades/agendadas',
      name: 'atividade-agendada',
      component: asyncView('atividade/agenda/Listar'),
      meta: {
        title: 'Atividades Agendadas',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/atividades/criar',
      name: 'nova-atividade',
      component: asyncView('atividade/Form'),
      meta: {
        title: 'Nova Atividade',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/atividades/:id',
      name: 'Ver Atividade',
      component: asyncView('atividade/Exibir'),
      meta: {
        title: 'Ver Atividade',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/atividades/:id/editar',
      name: 'Editar Atividade',
      component: asyncView('atividade/Form'),
      meta: {
        title: 'Editar Atividade',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/comunicados',
      name: 'listar-comunicados',
      component: asyncView('comunicado/Listar'),
      meta: {
        title: 'Comunicados',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/comunicados/criar',
      name: 'novo-comunicado',
      component: asyncView('comunicado/Criar'),
      meta: {
        title: 'Novo Comunicado',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/comunicados/:id/editar',
      name: 'editar-comunicado',
      component: asyncView('comunicado/Criar'),
      meta: {
        title: 'Editar Comunicado',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/comunicados/:id',
      name: 'visualizar-comunicado',
      component: asyncView('comunicado/Exibir'),
      meta: {
        title: 'Ver Comunicado',
        noMenu: false,
        noAuth: false
      }
    },

    {
      path: '/eventos',
      name: 'listar-eventos',
      component: asyncView('evento/Listar'),
      meta: {
        title: 'Eventos',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/eventos/criar',
      name: 'novo-evento',
      component: asyncView('evento/Criar'),
      meta: {
        title: 'Novo Evento',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/eventos/:id/editar',
      name: 'editar-evento',
      component: asyncView('evento/Criar'),
      meta: {
        title: 'Editar Evento',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/eventos/:id',
      name: 'visualizar-evento',
      component: asyncView('evento/Exibir'),
      meta: {
        title: 'Ver Evento',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/mensagens',
      name: 'listar-mensagens',
      component: asyncView('mensagem/Listar'),
      meta: {
        title: 'Mensagens',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: asyncView('logout'),
      meta: {
        title: 'Logout',
        noMenu: true,
        noAuth: false
      },
      beforeEnter: (to, from, next) => {
        try {
          // Captura a URL de redirecionamento
          const redirectPath = encodeURIComponent(from.fullPath || '/')
          const escola = localStorage.getItem('escola') || ''

          // Redireciona para a página de login com os parâmetros apropriados
          next(`/login?redirect=${redirectPath}&escola=${escola}`)
        } catch (error) {
          console.error('Erro ao redirecionar após logout:', error)
          next('/login') // Redireciona para o login sem parâmetros no caso de erro
        }
      }
    },
    {
      path: '/login',
      name: 'login',
      component: asyncView('Login'),
      meta: {
        title: 'Login',
        noMenu: true,
        noAuth: true
      }
    },
    {
      path: '/login-by-token',
      name: 'login-by-token',
      component: asyncView('LoginByToken'),
      meta: {
        title: 'Login by Token',
        noMenu: true,
        noAuth: true
      }
    },
    {
      path: '/recuperar-senha',
      name: 'recuperar-senha',
      component: asyncView('PasswordReset'),
      meta: {
        title: 'Recuperar Senha',
        noMenu: true,
        noAuth: true
      }
    },
    {
      path: '/esqueci-senha',
      name: 'esqueci-senha',
      component: asyncView('ForgotPassword'),
      meta: {
        title: 'Esqueci a Senha',
        noMenu: true,
        noAuth: true
      }
    },
    {
      path: '/autorizacoes',
      name: 'autorizacoes',
      component: asyncView('autorizacao/Criar'),
      meta: {
        title: 'Autorizações',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/galerias',
      name: 'galerias',
      component: asyncView('galeria/Listar'),
      meta: {
        title: 'Galerias',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/galerias/criar',
      name: 'criar-galerias',
      component: asyncView('galeria/Form'),
      meta: {
        title: 'Nova Galeria',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/galerias/:id',
      name: 'listar-galerias',
      component: asyncView('galeria/Exibir'),
      meta: {
        title: 'Ver Galeria',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/galerias/:id/editar',
      name: 'editar-galerias',
      component: asyncView('galeria/Form'),
      meta: {
        title: 'Editar Galeria',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/refeicoes/criar',
      name: 'nova-refeicao',
      component: asyncView('refeicao/Criar'),
      meta: {
        title: 'Nova Refeição',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/refeicoes/venda',
      name: 'nova-refeicao',
      component: asyncView('refeicao/Venda'),
      meta: {
        title: 'Nova Venda',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/refeicoes',
      name: 'lista-refeicao',
      component: asyncView('refeicao/Listar'),
      meta: {
        title: 'Refeições',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/refeicoes/:id',
      name: 'ver-refeicao',
      component: asyncView('refeicao/Exibir'),
      meta: {
        title: 'Refeições',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/refeicoes/:id/editar',
      name: 'editar-refeicao',
      component: asyncView('refeicao/Criar'),
      meta: {
        title: 'Refeições',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/mensagens',
      name: 'mensagens',
      component: asyncView('mensagem/Listar'),
      meta: {
        title: 'Mensagens',
        noMenu: false,
        noAuth: false
      }
    },
    {
      path: '/mensagens/criar',
      component: asyncView('mensagem/Criar'),
      name: 'novo-grupo',
      meta: {
        title: 'Nova grupo',
        noAuth: false,
        noMenu: false
      }
    },
    {
      path: '/mensagens/:id/editar',
      component: asyncView('mensagem/Criar'),
      name: 'editar-grupo',
      meta: {
        title: 'Editar Grupo',
        noAuth: false,
        noMenu: false
      }
    },
    {
      path: '/mensagens/:id/',
      component: asyncView('mensagem/Exibir'),
      name: 'exibir-grupo',
      meta: {
        title: 'Exibir Grupo',
        noAuth: false,
        noMenu: false
      }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  try {
    if (to.meta.noAuth) {
      next()
      return
    }

    const isAuthenticated = Auth.isAuthenticated
    let hasValidToken = false

    if (isAuthenticated) {
      try {
        hasValidToken = await Auth.checkAccessToken()
      } catch (authError) {
        console.warn('Erro ao verificar o token:', authError)
      }
    }

    if (hasValidToken) {
      next()
    } else {
      let escola = to.query.escola || localStorage.getItem('escola') || ''

      if (to.query.escola) {
        localStorage.setItem('escola', to.query.escola)
      }

      const redirectPath = encodeURIComponent(
        to.fullPath.replace(/(\?|&)escola=[^&]+/, '')
      )

      next(`/login?redirect=${redirectPath}&escola=${escola}`)
    }
  } catch (error) {
    console.error('Erro no roteador:', error)
    next(`/login?redirect=/&escola=`)
  }
})

export default router
